import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { Card, Descriptions, Tag, Spin, Table, Button } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import dayjs from 'dayjs'
import { getAccountDetail, type Account } from '../api/admin'

const AccountDetail = () => {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()

  const { data, isLoading } = useQuery({
    queryKey: ['account', id],
    queryFn: () => getAccountDetail(Number(id)).then((res) => res.data.data),
  })

  if (isLoading) {
    return (
      <div style={{ textAlign: 'center', padding: '100px' }}>
        <Spin size="large" />
      </div>
    )
  }

  const account: Account | undefined = data?.account
  const apps = data?.apps || []

  const appColumns = [
    {
      title: '应用',
      dataIndex: 'app_name',
    },
    {
      title: '应用ID',
      dataIndex: 'app_id',
    },
    {
      title: '用户ID',
      dataIndex: 'user_id',
    },
    {
      title: '状态',
      dataIndex: 'status',
      render: (status: string) => (
        <Tag color={status === 'active' ? 'green' : 'red'}>
          {status === 'active' ? '活跃' : '已停用'}
        </Tag>
      ),
    },
    {
      title: '创建时间',
      dataIndex: 'created_at',
      render: (date: string) => dayjs(date).format('YYYY-MM-DD HH:mm'),
    },
  ]

  return (
    <div>
      <Button
        icon={<ArrowLeftOutlined />}
        onClick={() => navigate('/accounts')}
        style={{ marginBottom: 16 }}
      >
        返回列表
      </Button>
      <h2 style={{ marginBottom: 24 }}>账户详情</h2>
      
      <Card title="基本信息" style={{ marginBottom: 24 }}>
        <Descriptions bordered column={2}>
          <Descriptions.Item label="ID">{account?.id}</Descriptions.Item>
          <Descriptions.Item label="邮箱">{account?.email}</Descriptions.Item>
          <Descriptions.Item label="状态">
            <Tag color={account?.status === 'active' ? 'green' : account?.status === 'pending' ? 'orange' : 'red'}>
              {account?.status === 'active' ? '活跃' : account?.status === 'pending' ? '待验证' : '已禁用'}
            </Tag>
          </Descriptions.Item>
          <Descriptions.Item label="邮箱验证">
            <Tag color={account?.email_verified ? 'green' : 'red'}>
              {account?.email_verified ? '已验证' : '未验证'}
            </Tag>
          </Descriptions.Item>
          <Descriptions.Item label="创建时间">
            {dayjs(account?.created_at).format('YYYY-MM-DD HH:mm:ss')}
          </Descriptions.Item>
          <Descriptions.Item label="更新时间">
            {dayjs(account?.updated_at).format('YYYY-MM-DD HH:mm:ss')}
          </Descriptions.Item>
        </Descriptions>
      </Card>

      <Card title="应用关联">
        <Table
          columns={appColumns}
          dataSource={apps}
          rowKey="id"
          pagination={false}
        />
      </Card>
    </div>
  )
}

export default AccountDetail
